import BasicSignUpForm from './BasicSignUpForm'
import { prop } from 'ramda'
import { connect } from 'react-redux'

const mapStateToProps = ({ authentication }) => ({
  consent: prop('consent', authentication),
  email: prop('email', authentication),
  emailError: prop('emailError', authentication),
  password: prop('password', authentication),
  passwordError: prop('passwordError', authentication),
  revalidation: prop('revalidation', authentication)
})

export default connect(mapStateToProps)(BasicSignUpForm)
